"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlatformAnalyticsStore = exports.analyticsChangeCallback = exports.performanceMetrics = exports.trackEvent = exports.ClickTracker = exports.AnalyticsContextImpl = exports.AnalyticsContext = void 0;
var analytics_context_1 = require("./analytics-context");
Object.defineProperty(exports, "AnalyticsContext", {
  enumerable: true,
  get: function () {
    return analytics_context_1.AnalyticsContext;
  }
});
Object.defineProperty(exports, "AnalyticsContextImpl", {
  enumerable: true,
  get: function () {
    return analytics_context_1.AnalyticsContextImpl;
  }
});
var click_tracker_1 = require("./click-tracker");
Object.defineProperty(exports, "ClickTracker", {
  enumerable: true,
  get: function () {
    return click_tracker_1.ClickTracker;
  }
});
var track_event_1 = require("./track-event");
Object.defineProperty(exports, "trackEvent", {
  enumerable: true,
  get: function () {
    return track_event_1.trackEvent;
  }
});
var perf_metrics_1 = require("./perf-metrics");
Object.defineProperty(exports, "performanceMetrics", {
  enumerable: true,
  get: function () {
    return perf_metrics_1.performanceMetrics;
  }
});
var platform_analytics_store_1 = require("./prime/platform-analytics-store");
Object.defineProperty(exports, "PlatformAnalyticsStore", {
  enumerable: true,
  get: function () {
    return platform_analytics_store_1.PlatformAnalyticsStore;
  }
});
var analyticsChangeCallback = function () {
  platform_analytics_store_1.PlatformAnalyticsStore.resetAnalyticsForNewPage();
};
exports.analyticsChangeCallback = analyticsChangeCallback;